import React from 'react';
import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import './styles.scss';
import useTranslation from '../../hooks/useTranslation';

let Success = 'Success';
let Warning = 'Warning';
let ErrorTitle = 'Error';

const EpToaster = ({
  position, reverseOrder, duration, gutter,
}) => {
  // Tags do Globalization
  Success = useTranslation('Success');
  Warning = useTranslation('Warning');
  ErrorTitle = useTranslation('Error');

  return (
    <Toaster
      position={position}
      reverseOrder={reverseOrder}
      toastOptions={{ duration }}
      gutter={gutter}
    />
  );
};

const EpToast = ({
  color, title, description, id,
}) => (
  <div className="toasts">
    <div className="toasts__title">
      <h3 className={`toasts__title--${color}`}>{title}</h3>
      <button onClick={() => toast.dismiss(id)}>
        <FaTimes />
      </button>
    </div>
    <p className="toasts__message">{description}</p>
  </div>
);

export function showToast(
  color, title, description,
) {
  toast.custom(t => (
    <EpToast
      color={color}
      title={title}
      description={description}
      id={t.id}
    />
  ));
}

export const showToastDefault = (res, toasterTitle, toasterDescription) => {
  const errorCode = res.status || res.response.status;

  switch (errorCode) {
  case 200:
    return showToast('success', toasterTitle || Success, toasterDescription || res.statusText);
  case 204:
    return showToast('success', toasterTitle || Success, toasterDescription || res.statusText);
  case 422:
    return showToast('warning', toasterTitle || Warning, toasterDescription || res.message);
  default:
    return showToast('danger', toasterTitle || ErrorTitle, toasterDescription || res.message);
  }
};

export default EpToaster;

EpToast.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

EpToaster.defaultProps = {
  reverseOrder: false,
  gutter: 8,
  position: 'top-right',
};

EpToaster.propTypes = {
  position: PropTypes.oneOf(['top-left', 'top-right', 'bottom-left', 'bottom-right']),
  duration: PropTypes.number.isRequired,
  reverseOrder: PropTypes.bool,
  gutter: PropTypes.number,

};
